import { type UseQueryResult, useQuery } from 'react-query';
import { TaskTypeService } from '../../services/wealthlane-job-scheduler-services';

const useGetTaskTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const taskTypesOptions = useQuery(
    ['getTaskTypes'],
    async () => {
      return await handleRequest(TaskTypeService.getApiSchedulerApiAppTaskTypeTaskTypes());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return taskTypesOptions;
};

export default useGetTaskTypes;
